import { render, staticRenderFns } from "./ShoppingCartTable.vue?vue&type=template&id=07f060b9&scoped=true&"
import script from "./ShoppingCartTable.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartTable.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartTable.vue?vue&type=style&index=0&id=07f060b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f060b9",
  null
  
)

export default component.exports